import { motion } from "framer-motion";
import { ChevronRight, Pin, ArrowRight } from "lucide-react";

// Group header for the hub rail: label in group colour, hairline that fills when open, swinging chevron.
export default function NavGroupHeader({ group, open, onToggle, solo = false, asLink = false, pinned = false, active = false, hovered = false }) {
  const GIcon = group.Icon;
  const rgb = group.glowRgb || "var(--glow-home)";
  const link = solo || asLink;
  const lit = open || hovered;
  const slug = (group.slug || group.label).toLowerCase().replace(/[^a-z0-9]+/g, "-");
  const spring = { type: "spring", stiffness: 260, damping: 30 };

  return (
    <button
      type="button"
      onClick={onToggle}
      className="group/hdr w-full flex items-center gap-2 px-2 min-h-[44px] md:min-h-[32px] rounded-md select-none text-left relative"
      style={{ "--tile-rgb": rgb }}
      title={link ? `Open ${group.label}` : open ? `Close ${group.label}` : `Open ${group.label}`}
      aria-expanded={link ? undefined : open}
      data-testid={`nav-group-${slug}`}
    >
      {GIcon && (
        <GIcon
          className="w-[13px] h-[13px] flex-shrink-0 transition-[filter,color] duration-200"
          style={{ color: lit || active ? `rgb(${rgb})` : `rgba(${rgb},0.7)`, filter: lit ? `drop-shadow(0 0 6px rgba(${rgb},0.8))` : "none" }}
          strokeWidth={2.25}
        />
      )}
      <span
        className="text-[10px] font-black uppercase tracking-[0.16em] leading-[1.15] transition-colors duration-200 flex-shrink min-w-0"
        style={{ color: lit || active ? `rgb(${rgb})` : `rgba(${rgb},0.72)`, textShadow: lit ? `0 0 14px rgba(${rgb},0.5)` : "none" }}
      >
        {group.label}
      </span>
      <span className="relative flex-1 h-px overflow-hidden min-w-[12px]" style={{ background: `rgba(${rgb},0.14)` }}>
        <motion.span
          className="absolute inset-y-0 left-0"
          style={{ background: `rgb(${rgb})`, boxShadow: `0 0 8px rgba(${rgb},0.8)` }}
          initial={false}
          animate={{ width: lit || active ? "100%" : "0%" }}
          transition={spring}
        />
      </span>
      {pinned && !active && !link && (
        <Pin className="w-3 h-3 flex-shrink-0" style={{ color: `rgba(${rgb},0.8)` }} data-testid={`nav-group-pin-${slug}`} />
      )}
      {link ? (
        <ArrowRight
          className="w-3.5 h-3.5 flex-shrink-0 transition-transform duration-200 group-hover/hdr:translate-x-0.5"
          style={{ color: lit ? `rgb(${rgb})` : "rgb(var(--q-faint))" }}
          strokeWidth={2.5}
        />
      ) : (
        <motion.span
          initial={false}
          animate={{ rotate: open ? 90 : 0 }}
          transition={{ type: "spring", stiffness: 420, damping: 26 }}
          className="inline-flex flex-shrink-0"
        >
          <ChevronRight className="w-3.5 h-3.5" style={{ color: lit ? `rgb(${rgb})` : "rgb(var(--q-faint))" }} strokeWidth={2.5} />
        </motion.span>
      )}
    </button>
  );
}
